export default __webpack_public_path__ + "static/media/register.c4336e1d.png";